module.exports = __webpack_public_path__ + "img/meetingclient10.98f9236f.png";